import React, { memo } from "react";
import Spin from 'antd/lib/spin';
import styles from './LoadingBlock.module.scss';

const LoadingBlock = () => (
	<div className={styles.loading} role="status" aria-label="Loading" aria-live="polite" aria-busy="true">
		<Spin size="large" />
	</div>
);

export default memo(LoadingBlock);
